import React from "react";
import { Flex, Box } from "rebass";
import styled, { keyframes, css } from "styled-components";
import PropTypes from "prop-types";

const childrenPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

const marquee = keyframes`
  from {
    transform: translate3d(100%, 0, 0);
  }
  to {
    transform: translate3d(-100%, 0, 0);
  }
`;
const MarqueeText = styled.div`
  position: absolute;
  right: 0;
  transform: translateX(100%);
  will-change: transform;
`;

export const Marquee = ({ children, ...rest }) => (
  <Flex
    fontFamily="regular"
    fontWeight="bold"
    lineHeight="1"
    color="red"
    css={css`
      position: relative;
      z-index: 1;
      text-transform: uppercase;
      white-space: nowrap;
      overflow: hidden;
      border-bottom: 1px solid;
      height: 69px;
      font-size: 70px;
      @media (min-width: 1024px) {
        height: 6vw;
        font-size: 6vw;
      }
    `}
    {...rest}
  >
    <MarqueeText
      css={css`
        animation: ${marquee} 48s linear infinite;
      `}
    >
      <Box as="span" mr={4}>
        {children}
      </Box>
      <Box as="span" mr={4}>
        {children}
      </Box>
    </MarqueeText>
    <MarqueeText
      css={css`
        animation: ${marquee} 48s linear infinite;
        animation-delay: 24s;
      `}
    >
      <Box as="span" mr={4}>
        {children}
      </Box>
      <Box as="span" mr={4}>
        {children}
      </Box>
    </MarqueeText>
  </Flex>
);

Marquee.propTypes = {
  ...childrenPropTypes,
};
